let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dhhgc")).then(() => parcelRequire('4QwTg'));